import React, { FC } from 'react';
import DesktopTooltip from 'generic/DesktopTooltip';
import nanoid from 'nanoid';
import { Item as ItemContainer } from './ItemStyles';

interface IData {
  data: any;
  name: string;
}

interface IItem {
  data: IData;
  icon: string;
}

const Item: FC<IItem> = ({ data: { data, name }, icon }) => {
  if (!data) return null;
  const id = nanoid();
  return (
    <ItemContainer>
      <img width="16px" height="16px" src={icon} alt="icon" className="icon" />
      <span className="text" data-tip data-for={`param-${id}`}>
        {data}
      </span>
      <DesktopTooltip id={`param-${id}`} effect="solid" place="top">
        {name}
      </DesktopTooltip>
    </ItemContainer>
  );
};

export default Item;
